var console = require("./logger.js");
var Util = require("./util.js");


function CallbackTable () {

    //console.log(__GLOBAL_LOG_PREFIX__, "[" + CallbackTable.name + "][constructor] Enter");
    this._callbackTable = [];
}
CallbackTable.name = "CallbackTable";

// "id1@namespace1 id2 id3@namespace2"
CallbackTable.prototype.addCallback = function (id, callback, context, namespace, isRunOnce) {

    if (id == null || callback == null ||
        typeof id !== "string" || id === "" ||
        typeof callback !== "function") {

        console.error(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][addCallback] Invalid parameter");
        return this;
    }

    if (isRunOnce == null) {
    
        isRunOnce = false;
    }

    var idArray = id.split(" ");

    for (var index = 0; index < idArray.length; index++) {

        var tmp = idArray[index].split("@");

        var idTmp = tmp[0];

        var namespaceTmp = namespace;

        if (tmp.length > 1) {

            namespaceTmp = tmp[1];
        }

        var isRunOnceTmp = false;

        var match = idTmp.match(/^\^(.*)/);

        if (match != null) {

            idTmp = match[1];
            isRunOnceTmp = true;
        }

        isRunOnceTmp = (isRunOnceTmp || isRunOnce);

        this._addCallback(idTmp, callback, context, namespaceTmp, isRunOnceTmp);
    }

    return this;
};

CallbackTable.prototype._addCallback = function (id, callback, context, namespace, isRunOnce) {


    if (id == null ||
        typeof id !== "string" ||
        id === "") {

        console.error(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][addCallback] Invalid parameter");
        return;
    }

    if (namespace === "") {

        namespace = null;
    }

    var callbackObject = {
        id: id,
        callback: callback,
        regexp: null,
        matchAll: false,
        context: context,
        namespace: namespace,
        isRunOnce: isRunOnce
    };

    var callbackTable = this._callbackTable;

    if (Util.hasWildcard(callbackObject.id)) {

        callbackObject.matchAll = (Util.reduceWildcard(callbackObject.id) === "*");

        if (callbackObject.matchAll === false) {

            callbackObject.regexp = new RegExp(Util.messageIdWildcard2RegExp(callbackObject.id));
        }
    }

    callbackTable.push(callbackObject);
};

CallbackTable.prototype.removeCallback = function (id, callback, context, namespace) {

    if (id == null) {

        id = "";
    }

    var idArray = id.split(" ");

    for (var index = 0; index < idArray.length; index++) {

        var tmp = idArray[index].split("@");

        var idTmp = tmp[0];

        var namespaceTmp = namespace;

        if (tmp.length > 1) {

            namespaceTmp = tmp[1];
        }

        this._removeCallback(idTmp, callback, context, namespaceTmp);
    }

    return this;
};

CallbackTable.prototype._removeCallback = function (id, callback, context, namespace) {

    if (id === "") {

        id = null;
    }

    if (namespace === "") {

        namespace = null;
    }

    var callbackTableTmp = [];
    var callbackTable = this._callbackTable;

    var nullFunction = function () {};
    
    for (var i = 0; i < callbackTable.length; i++) {

        var callbackObject = callbackTable[i];
        
        if (callbackObject != null) {

            if (id != null &&
                id !== callbackObject.id) {
                    
                callbackTableTmp.push(callbackObject);
                continue;
            }

            if (callback != null &&
                callback !== callbackObject.callback) {

                callbackTableTmp.push(callbackObject);
                continue;
            }

            if (context != null &&
                context !== callbackObject.context) {
                
                callbackTableTmp.push(callbackObject);
                continue;
            }
            
            if (namespace != null &&
                namespace !== callbackObject.namespace) {
                
                callbackTableTmp.push(callbackObject);
                continue;
            }            

            // remove immediatly
            callbackTable[i] = null;
            callbackObject.callback = nullFunction;
        }
    }

    this._callbackTable = callbackTableTmp;
};

CallbackTable.prototype.getCallbackArray = function (id) {

    var callbackArray = [];

    if (id == null ||
        typeof id !== "string" ||
        Util.hasWildcard(id)) {

        console.error(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][getCallbackArray] Invalid parameter");
        return callbackArray;
    }
    
    var callbackTable = this._callbackTable;
    var callbackTableTmp = [];

    for (var i = 0; i < callbackTable.length; i++) {

        var isMatched = false;
        var callbackObjectTmp = callbackTable[i];

        if (callbackObjectTmp != null) {

            if (callbackObjectTmp.regexp == null) {

                if (callbackObjectTmp.matchAll === true ||
                    callbackObjectTmp.id === id) {
                
                    isMatched = true;
                }
            } else {

                var matchedParts = id.match(callbackObjectTmp.regexp);

                if (matchedParts != null && matchedParts[0] === id) {
                
                    isMatched = true;
                }
            }
        }
        
        if (isMatched === true) {
        
            callbackArray.push({
                callback: callbackObjectTmp.callback,
                context: callbackObjectTmp.context
            });
            
            if (callbackObjectTmp.isRunOnce === false) {
            
                callbackTableTmp.push(callbackObjectTmp);
            }
            
        } else {
        
            callbackTableTmp.push(callbackObjectTmp);
        }
    }
    
    this._callbackTable = callbackTableTmp;

    return callbackArray;

};

CallbackTable.prototype.getCallbackCount = function () {

    return this._callbackTable.length;
};

module.exports = CallbackTable;
